import { fromFloyd, getCurrencySymbol } from '@/lib/currency';
import { type IDirectDiscount } from '@/types/content';

export const getAppliedDiscount = (
	codeUnderTest: string | null | undefined,
	propertyDiscounts: IDirectDiscount[],
) => {
	if (codeUnderTest === undefined) {
		return undefined;
	}

	if (typeof codeUnderTest !== 'string') {
		return null;
	}

	return (
		propertyDiscounts.find((d, _i) => {
			return (
				d.discountCode === codeUnderTest &&
				(!d.expiresAt || new Date(d.expiresAt) >= new Date()) &&
				d.active
			);
		}) ?? null
	);
};

export const formatDiscountAmount = (
	discount: IDirectDiscount,
	currency: string,
) => {
	if (discount.discountType === 'fixed') {
		return `${getCurrencySymbol(currency)}${fromFloyd(discount.discountAmount).toFixed(2)}`;
	} else if (discount.discountType === 'percentage') {
		return `${discount.discountAmount * 100}%`;
	}
};
